
import Vue from "vue";

export default Vue.extend({
  name: "RecruiterCandidateInformationDialog",
  props: {
    profile: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      // Remote assets provided by the Figma node spec (valid for ~7 days).
      careerIconUrl:
        "https://www.figma.com/api/mcp/asset/4e27eaa7-5c5c-46ec-b8f9-d699aa22c0e5",
      educationIconUrl:
        "https://www.figma.com/api/mcp/asset/bfc26489-ed38-460f-8f80-0756c25f6e14",
      certIconUrl:
        "https://www.figma.com/api/mcp/asset/65c2eac0-bd08-4345-b326-4746e1cd6b84",
      timelineLineUrl:
        "https://www.figma.com/api/mcp/asset/d407d4c3-ef00-4978-9ebb-dfa788d69fdb",
      employmentType: "Full-time"
    };
  },
  computed: {
    locationText(): string {
      const loc = (this.profile as any)?.personal_details?.location;
      if (!loc) return "-";
      return (
        loc.text ||
        [loc.city, loc.Country].filter((v: any) => v).join(", ") ||
        "-"
      );
    },
    careerHistory(): any[] {
      const work = (this.profile as any)?.work_history_detailed;
      if (!work) return [];
      return Object.values(work);
    },
    educationHistory(): any[] {
      const edu = (this.profile as any)?.education_detailed;
      if (!edu) return [];
      return Object.values(edu);
    },
    certificationHistory(): any[] {
      const certs = (this.profile as any)?.certification_detailed;
      if (!certs) return [];
      return Object.values(certs);
    }
  }
});
